<template>
  <div>
    <b-row class="mt-4">
      <b-col cols="1">
        <h3 class="text-info m-1">1.</h3>
      </b-col>

      <b-col cols="11" sm="5">
        <ulu-multiselect class="m-1" v-model="customerObj" :options="customers" label="name" track-by="name"
          :placeholder="$t('globals.select_customer')" />
      </b-col>
      <b-col cols="12" sm="6">
        <b-btn size="md" class="m-1" variant="info" @click="setShowNewCustomerModal(true)">
          <icon name="user-plus"></icon> {{ $t("globals.add_new") }}
        </b-btn>
      </b-col>
    </b-row>
    <ulu-new-customer-modal :setNewCustomer="setNewCustomer" />
    <b-modal :visible="showExistingInquiriesModal" hide-footer hide-header centered>
      <h5 class="text-info">{{ $t("globals.existing_inquiries") }}:</h5>
      <b-table :caption="$t('globals.click_on_inquiry_redirect')" small hover bordered :items="existingInquiries"
        @row-clicked="rowClicked">
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import "vue-awesome/icons/user-plus";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-multiselect": () => import("vue-multiselect"),
    "ulu-new-customer-modal": () =>
      import(
        "@/components/inquiries/new_inquiry/select_customer/NewCustomerModal"
      )
  },
  data() {
    return {
      customerObj: null,
      customers: [],
      existingInquiries: [],
      showExistingInquiriesModal: false
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations([
      "setShowLoadingModal",
      "setShowNewCustomerModal",
      "setCustomerSet",
      "setNewInquiryCustomerId",
      "setNewInquiryCustomerCountry",
      "setNewInquiryCustomerNotes"
    ]),
    setNewCustomer(id, name, country) {
      this.customerObj = {
        id: id,
        name: name,
        country: country
      };
    },
    rowClicked(item) {
      this.$router.push({ name: "inquiry", params: { id: item.id } });
    },
    fetchAllCustomers() {
      this.setShowLoadingModal(true);
      const data = {
        query: `
          query { 
            CustomersAll (type: "company") {
              id
              name: company_name
              country: company_country
              notes
            }
          }
        `
      };

      this.simpleFetch({ data, this_ref: this }).then((res) => {
        if (res) {
          this.customers = res.CustomersAll
        }
      }).finally(() => {
        this.setShowLoadingModal(false);
      });
    },
    checkForExistingInquiries(customerId) {
      const data = {
        query: `
          query { 
            allInquiriesByCustomer(customer_id: ${parseInt(customerId)}) {
              id
              created_at
              status
              agent {
                full_name
              }
            }
          }
        `
      };

      axios
        .post(this.getGraphQlUrl, data, this.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else if (res.data.data.allInquiriesByCustomer.length > 0) {
            this.existingInquiries = res.data.data.allInquiriesByCustomer.map(
              inquiry => {
                return {
                  id: inquiry.id,
                  created_at: inquiry.created_at.substring(0, 10),
                  status: inquiry.status,
                  agent: inquiry.agent.full_name
                };
              }
            );
            this.showExistingInquiriesModal = true;
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        });
    }
  },
  computed: {
    ...mapGetters(["getDefConf", "getGraphQlUrl"])
  },
  watch: {
    customerObj: function () {
      this.setCustomerSet(true);
      this.setNewInquiryCustomerId(this.customerObj.id);
      this.setNewInquiryCustomerNotes(this.customerObj.notes);
      this.setNewInquiryCustomerCountry(this.customerObj.country);
      this.checkForExistingInquiries(this.customerObj.id);
    }
  },
  created() {
    this.fetchAllCustomers();
  },
  beforeDestroy() {
    this.setShowNewCustomerModal(false);
    this.showExistingInquiriesModal = false;
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
